import React from "react";
import "../../styles/style-ind.css";
import { useMediaQuery } from "react-responsive";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation,
  useMatch,
  useMatches,
  useLoaderData,
} from "react-router-dom";

const SectionOne = () => {
  const indian_brand = [
    {
      icon: "assets/images/kwikpricing/foxtale.png",
      width: "90",
    },
    {
      icon: "assets/images/kwikpricing/levis.png",
      width: "100",
    },
    {
      icon: "assets/images/kwikpricing/adil.png",
      width: "114",
    },
    {
      icon: "assets/images/kwikpricing/caffeine.png",
      width: "70",
    },
    {
      icon: "assets/images/kwikpricing/bsc.png",
      width: "60",
    },
    {
      icon: "assets/images/kwikpricing/plix.png",
      width: "70",
    },
      {
      icon: "assets/images/kwikpricing/justherb.png",
      width: "150",
    },
  ];

  const growth_feature = [
    {
      title: "14 day free trial",
    },
    {
      title: "Whatsapp Marketing",
    },
    {
      title: "Broadcast Campaigns",
    },
    {
      title: "DIY Automations",
    },
    {
      title: "Customer Segmentation",
    },
    {
      title: "Smart Retry",
    },
    {
      title: "Support – Chat Panel",
    },
    {
      title: "DIY Chatbot Builder",
    },
  ];

  const pro_feature = [
    {
      title: "Everything in Growth",
    },
    {
      title: "FB + Instagram",
    },
    {
      title: "SMS + Email",
    },
    {
      title: "KwikPass Integration",
    },
    {
      title: "Kwik Insights",
    },
    {
      title: "AI Chatbot",
    },
    {
      title: "Custom Automations",
    },
    {
      title: "RFM + Cohort Analysis",
    },
    {
      title: "A/B Testing",
    },
    {
      title: "Dedicated customer success manager",
    },
  ];

  const enterprise_feature = [
    {
      title: "Everything in Pro",
    },
    {
      title: "AI Calling",
    },
    {
      title: "Custom Events",
    },
    {
      title: "Live Segments",
    },
    {
      title: "App Integrations (e.g., Appbrew)",
    },
    {
      title: "Dedicated customer success manager",
    },
  ];

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="price-ind">
      <div
        style={{
          display: "flex",
          gap: "25px",
          justifyContent: "space-between",
        }}
      >
        <img
          src="/assets/images/logo@2x.png"
          width="137"
          height="40"
          alt="GoKwik"
        />
        <button className="cta-price-talk-contact">
          <Link to="/contact" style={{ color: "white" }}>
            Contact Us
          </Link>
        </button>
      </div>
      <div className="container-fluid ">
        <div className="sec1-price-ind">
          <h1>Our Customers Make 5X for Every ₹1 Spent</h1>
          <p>
            Plans built to help D2C brands recover more carts, drive repeat
            purchases, and increase revenue.
          </p>
          <div className="cta-btn-sec">
            <a
              href="https://apps.shopify.com/kwikengage?utm_source=pricingpage&utm_medium=shopify"
              target="_blank"
              style={{ color: "black" }}
            >
              <button className="cta-price-get">Get Started</button>
            </a>
            <Link to="/contact">
              <button className="cta-price-talk">Talk to Sales</button>
            </Link>
          </div>

          <h3 style={{ marginTop: "50px" }}>Trusted by 10,000+ brands</h3>

          <div className="brand-logo">
            {indian_brand.map((data, idx) => (
              <img
                src={data.icon}
                alt="Brand"
                style={{ width: `${data.width}px` }}
              />
            ))}
          </div>

          {!isMobile ? (
            <div className="mac-lap-container">
              <div className="mac-lap">
                <img src="assets/images/kwikpricing/Macbook.svg" alt="Mac" />
                <div className="pricing-overlay">
                  {/* Pricing Table */}
                  <div className="pricing-table">
                    {/* Growth */}
                    <div className="pricing-growth">
                      <h4 style={{ fontWeight: "500" }}>Growth</h4>
                      <p style={{ color: "#363636" }}>
                        Best for early-stage D2C brands starting engagement
                        campaigns.
                      </p>
                      <h2 className="price">Starting ₹3.8k</h2>
                      <p style={{ color: "#363636" }}>per month</p>

                      <div>
                        {growth_feature.map((data, idx) => (
                          <div className="check-feature">
                            <img
                              src="/assets/images/kwikpricing/check-fea.png"
                              alt=""
                              width="10px"
                            />
                            <p>{data.title}</p>
                          </div>
                        ))}
                      </div>

                      <a
                        href="https://apps.shopify.com/kwikengage?utm_source=pricingpage&utm_medium=shopify"
                        target="_blank"
                        style={{ color: "black" }}
                      >
                        <div
                          className="start-now-btn"
                          style={{ marginTop: "90px", fontWeight: "600" }}
                        >
                          Start Now
                        </div>
                      </a>
                    </div>

                    {/* Pro */}
                    <div className="pro">
                      <div className="badge">Most Popular</div>
                      <h4 style={{ fontWeight: "500" }}>Pro</h4>
                      <p style={{ color: "#363636" }}>
                        Advanced automation & multi-channel retargeting for
                        growing brands.
                      </p>
                      <h2 className="price">Starting ₹30k</h2>
                      <p style={{ color: "#363636" }}>per month</p>

                      <div>
                        {pro_feature.map((data, idx) => (
                          <div className="check-feature" key={idx}>
                            <img
                              src="/assets/images/kwikpricing/check-fea.png"
                              alt=""
                              width="10px"
                            />
                            <p>{data.title}</p>
                          </div>
                        ))}
                      </div>

                      <a
                        href="https://apps.shopify.com/kwikengage?utm_source=pricingpage&utm_medium=shopify"
                        target="_blank"
                        style={{ color: "black" }}
                      >
                        <div
                          className="start-now-btn-pro"
                          style={{
                            backgroundColor: "#2800FF",
                            color: "white",
                            fontWeight: "600",
                          }}
                        >
                          Start Now
                        </div>
                      </a>
                    </div>

                    {/* enterprise */}
                    <div className="enterprise">
                      <h4 style={{ fontWeight: "500" }}>Enterprise</h4>
                      <p style={{ color: "#363636" }}>
                        Custom solutions for large-scale, high-volume D2C
                        leaders.
                      </p>
                      <h2 className="price">Custom</h2>
                      <p style={{ color: "#363636" }}>per month</p>
                      <div>
                        {enterprise_feature.map((data, idx) => (
                          <div className="check-feature">
                            <img
                              src="/assets/images/kwikpricing/check-fea.png"
                              alt=""
                              width="10px"
                            />
                            <p>{data.title}</p>
                          </div>
                        ))}
                      </div>
                      <Link to="/contact" style={{ color: "black" }}>
                        <div
                          className="start-now-btn"
                          style={{ marginTop: "123px", fontWeight: "600" }}
                        >
                          Talk to Us
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="" style={{ color: "black" }}>
              <div className="pricing-growth mb-4" style={{ width: "280px" }}>
                <h4>Growth</h4>
                <p style={{ color: "#363636" }}>
                  Best for early-stage D2C brands starting engagement campaigns.
                </p>
                <h2 className="price">Starting ₹3.8k</h2>
                <p style={{ color: "#363636" }}>per month</p>

                <div>
                  {growth_feature.map((data, idx) => (
                    <div className="check-feature">
                      <img
                        src="/assets/images/kwikpricing/check-fea.png"
                        alt=""
                        width="10px"
                      />
                      <p>{data.title}</p>
                    </div>
                  ))}
                </div>

                <div
                  className="start-now-btn"
                  style={{ marginTop: "83px", fontWeight: "600" }}
                >
                  Start Now
                </div>
              </div>

              {/* Pro */}
              <div className="pro mb-4" style={{ width: "280px" }}>
                <div className="badge">Most Popular</div>
                <h4>Pro</h4>
                <p style={{ color: "#363636" }}>
                  Advanced automation & multi-channel retargeting for growing
                  brands.
                </p>
                <h2 className="price">Starting ₹30k</h2>
                <p style={{ color: "#363636" }}>per month</p>

                <div>
                  {pro_feature.map((data, idx) => (
                    <div className="check-feature">
                      <img
                        src="/assets/images/kwikpricing/check-fea.png"
                        alt=""
                        width="10px"
                      />
                      <p>{data.title}</p>
                    </div>
                  ))}
                </div>
                <div
                  className="start-now-btn"
                  style={{
                    backgroundColor: "#2800FF",
                    color: "white",
                    margin: "30px 10px",
                    fontWeight: "600",
                  }}
                >
                  Start Now
                </div>
              </div>

              {/* enterprise */}
              <div className="enterprise mb-4" style={{ width: "280px" }}>
                <h4>Enterprise</h4>
                <p style={{ color: "#363636" }}>
                  Custom solutions for large-scale, high-volume D2C leaders.
                </p>
                <h2 className="price">Custom</h2>
                <p style={{ color: "#363636" }}>per month</p>
                <div>
                  {enterprise_feature.map((data, idx) => (
                    <div className="check-feature">
                      <img
                        src="/assets/images/kwikpricing/check-fea.png"
                        alt=""
                        width="10px"
                      />
                      <p>{data.title}</p>
                    </div>
                  ))}
                </div>
                <div
                  className="start-now-btn"
                  style={{ marginTop: "140px", fontWeight: "600" }}
                >
                  Talk to Us
                </div>
              </div>
            </div>
          )}

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
